import React from 'react'
import { LineChart, Line, XAxis, Tooltip, YAxis } from 'recharts';




function Chart(props) {

  const { clickWeekly, loading, clickMonthly, clickYearly, sectionTitle, sectionName, dataSet, width, height, dataKey, dataKeyName, strokeColor, navClass, graphTotalText } = props
  const TotalWeeklyCount  = dataSet.weeklyData  && dataSet.weeklyData.totalData
  const TotalMonthlyCount = dataSet.monthlyData && dataSet.monthlyData.totalData
  const TotalYearlyCount  = dataSet.yearlyData  && dataSet.yearlyData.totalData
  
  return (
    <>
      <div className="share-graph">
        <div className="row">
          <div className="col-6">
            <h4 className="section-social-name">{sectionTitle}</h4>
          </div>
          <div className="col-6">
              <ul className={`nav nav-pills ${navClass ? navClass : 'justify-content-between'}`} id={`${sectionName}-tab`} role="tablist">
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item active"
                    id={`${sectionName}-home-tab`}
                    href={`#${sectionName}-home`}
                    role="tab"
                    data-toggle="tab"
                    aria-controls={`${sectionName}-home`}
                    aria-selected="false"
                    onClick={clickWeekly}
                  >
                    Weekly
                </span>
                </li>
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item"
                    id={`${sectionName}-profile-tab`}
                    href={`#${sectionName}-profile`}
                    role="tab"
                    data-toggle="tab"
                    aria-controls={`${sectionName}-profile`}
                    aria-selected="false"
                    onClick={clickMonthly}
                  >
                    Monthly
                </span>
                </li>
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item"
                    id={`${sectionName}-contact-tab`}
                    href={`#${sectionName}-contact`}
                    role="tab"
                    data-toggle="tab"
                    aria-controls={`${sectionName}-contact`}
                    aria-selected="false"
                    onClick={clickYearly}
                  >
                    Yearly
                </span>
                </li>
              </ul>
          </div>
        </div>
        <div className="tab-content" id={`${sectionName}-tabContent`}>
        {loading && loading ? (
           <div className="my-5 text-center">
              <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
           </div>
            )
            :
            (<>
            <div
            className="tab-pane fade show active"
            id={`${sectionName}-home`}
            role="tabpanel"
            aria-labelledby={`${sectionName}-home-tab`}
          >
            <LineChart width={width} height={height} data={dataSet.weeklyData && dataSet.weeklyData.data}>
              <Line type="monotone" dataKey={dataKey} stroke="rgb(206,162,82)" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip /> 
            </LineChart>
            <h6 className="mb-0 text-center text-secondary font-weight-bold">{props.graphTotalText === undefined ? 'Captured Data This Week' : graphTotalText.week}: {TotalWeeklyCount} </h6>
          </div>
            <div
            className="tab-pane fade show"
            id={`${sectionName}-profile`}
            role="tabpanel"
            aria-labelledby={`${sectionName}-profile-tab`}
          >
            <LineChart width={width} height={height} data={dataSet.monthlyData && dataSet.monthlyData.data}>
              <Line type="monotone" dataKey={dataKey} stroke="rgb(206,162,82)" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
            </LineChart>
            <h6 className="mb-0 text-center text-secondary font-weight-bold">{props.graphTotalText === undefined ? 'Captured Data This Month' : graphTotalText.month}: {TotalMonthlyCount} </h6>
          </div>
            <div
            className="tab-pane fade show"
            id={`${sectionName}-contact`}
            role="tabpanel"
            aria-labelledby={`${sectionName}-contact-tab`}
          >
            <LineChart width={width} height={height} data={dataSet.yearlyData && dataSet.yearlyData.data}>
              
              <Line type="monotone" dataKey={dataKey} stroke="rgb(206,162,82)" />
              <XAxis dataKey="name" ticks={{autoSkip: false}} />
              <YAxis />
              <Tooltip />
            </LineChart>
            <h6 className="mb-0 text-center text-secondary font-weight-bold">{props.graphTotalText === undefined ? 'Captured Data This Week' : graphTotalText.year}: {TotalYearlyCount} </h6>
          </div>
              </>)}
        </div>
      </div>



    </>
  )
}

export default Chart
